<template>
  <card>
    <template slot="header">
      <h4 class="card-title">{{ $t("dashboard.repairsmodel_title") }}</h4>
      <p class="card-category text-muted">{{ $t("dashboard.repairsmodel_subtitle") }}</p>
    </template>
    <br>
    <div class="container py-4">
      <bar v-if="loaded" :chartdata="chartdata" :options="options" style="height: 270px"></bar>
    </div>

    <div class="mt-2 h6" v-if="loaded">
      <slot v-for="(label, index) in chartdata.labels">
        <small class="mr-2 d-inline-block" :key="index">
          <i class="fas fa-circle" :style="'color:'+colors.fill[index]"></i>
          {{ label }}
        </small>
      </slot>
    </div>
  </card>
</template>

<script>
import { Bar } from "@/components/index";
import $http from "@/helpers/api";
import { generateColors } from "@/helpers/filters";
export default {
  name: "RepairEquipmentBarChart",
  components: { Bar },
  data: () => ({
    loaded: false,
    colors: [],
    chartdata: {
      labels: [],
      datasets: []
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            display: false
          }
        ],

        // And this will affect the horizontal lines (yAxe) of your dataset
        yAxes: [
          {
            gridLines: {
              drawBorder: false,
              borderDash: [3, 3]
            }
          }
        ]
      }
    }
  }),
  mounted() {
    this.loaded = false;
    $http.get("/graph/repairsbyequipment").then(resp => {
      this.colors = {
        fill: generateColors(resp.data.data.length, "B3"),
        border: generateColors(resp.data.data.length)
      };
      this.chartdata = {
        labels: resp.data.label,
        datasets: [
          {
            label: "Total of repairs by Model",
            data: resp.data.data,
            backgroundColor: this.colors.fill,
            borderColor: this.colors.border,
            borderWidth: "1",
            hoverBackgroundColor: this.colors.border
          }
        ]
      };
      this.loaded = true;
    });
  }
};
</script>
